import { render, staticRenderFns } from "./myReviewTask.vue?vue&type=template&id=505e17da&scoped=true"
import script from "./myReviewTask.vue?vue&type=script&lang=js"
export * from "./myReviewTask.vue?vue&type=script&lang=js"
import style0 from "./myReviewTask.vue?vue&type=style&index=0&id=505e17da&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e17da",
  null
  
)

export default component.exports